import { type WrappedInsightPatientsHelpedAttributes } from "@clipboard-health/contract-worker-app-bff";
import { Image, Text } from "@clipboard-health/ui-components";
import trophyImagePath from "@src/appV2/lib/assets/images/cbh-wrapped/trophy.png";

import { InsightContentWrapper } from "../InsightContentWrapper";

interface PatientsHelpedContentProps {
  attributes: WrappedInsightPatientsHelpedAttributes;
}

export function PatientsHelpedContent(props: PatientsHelpedContentProps) {
  const { attributes } = props;

  return (
    <InsightContentWrapper>
      <Text
        variant="h1"
        sx={(theme) => ({
          fontSize: "4rem",
          marginTop: theme.spacing(5),
        })}
      >
        {attributes.patientsHelped}
      </Text>

      <Text
        variant="h3"
        sx={(theme) => ({
          color: theme.palette.text.tertiary,
          paddingBottom: 4,
          textWrap: "balance",
        })}
      >
        Patients whose trust you&apos;ve earned!
      </Text>

      <Image src={trophyImagePath} alt="Trophy" sx={{ position: "absolute", bottom: 0, left: 0 }} />
    </InsightContentWrapper>
  );
}
